import { z } from "zod";

export const getCompanyFormSchema = () => {
	return z.object({
		name: z.string(),
		email: z.string().email(),
		phone: z.string(),
		city: z.string(),
		country: z.string(),
		street: z.string(),
		buildingNumber: z.string(),
		postCode: z.string(),
		businessId: z.string(),
		vatId: z.string().nullish(),
		invoiceDueDays: z.number().nullish(),
	});
};

export type CompanyFormModel = z.infer<ReturnType<typeof getCompanyFormSchema>>;
